<template>
  <v-container class="signup-view">
    <page-title :title="$t('auth.signup.page_title')"></page-title>
    <h1 v-if="!hideForm" class="title" v-html="$t('auth.signup.section_title')"></h1>
    <h2 v-if="hideForm">Please check your inbox to start using the platform</h2>
    <form action="/login" @submit.prevent="submit" class="signup-form">
      <v-layout column v-if="!hideForm">
        <v-flex class="text-input-container">
          <label> {{ $t('email') }} </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.username"
            solo
            v-validate="'required|email|max:50'"
            :error-messages="errors.collect('username')"
            data-vv-name="username"
            counter="50"
          ></v-text-field>
        </v-flex>
        <v-flex class="text-input-container">
          <label> {{ $t('password') }} </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.password"
            solo
            type="password"
            name="password"
            autocomplete="current-password"
            v-validate="'required|min:8'"
            :error-messages="errors.collect('password')"
            data-vv-name="password"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row justify-center v-if="!hideForm">
        <v-btn
          color="primary"
          type="submit"
          :loading="submitLoading"
          depressed
          round
          large
          >{{ $t('submit') }}</v-btn
        >
      </v-layout>
    </form>
    <TwoColumnBottomAction>
      {{ $t('auth.signup.already_have_account') }}
      <router-link class="link" to="login">{{
        $t('auth.login.page_title')
      }}</router-link>
    </TwoColumnBottomAction>
  </v-container>
</template>

<script>
import formMixins from '@/mixins/forms'
import TwoColumnBottomAction from '@/components/auth/TwoColumnBottomAction.vue'
import routes from '@/route_names'
export default {
  name: 'Login',
  mixins: [formMixins],
  components: { TwoColumnBottomAction },
  data: function() {
    return {
      formData: {
        username: '',
        password: ''
      },
      hideForm: false
    }
  },
  methods: {
    getFormSubmitPromise: function() {
      const vm = this
      return this.$store
        .dispatch('user/signup', this.formData)
        .then(function(res) {
          vm.hideForm = true
          // vm.$router.push({
          //   name: routes.WIZARD
          // })
        })
    }
  }
}
</script>

<style lang="stylus">
@import "common.styl";
.signup-view {
    h1 {
        margin-bottom 30px
        color: var(--v-primary-base)
    }
}
.signup-form {
    max-width: 350px;
    margin auto
}
</style>
